var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayHamburgerMenuHeadset = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.72 2.5C7.078 2.506 2.506 7.078 2.5 12.72v8.03c0 1.21.98 2.19 2.19 2.19h2.92a.73.73 0 0 0 .73-.73v-7.3a.73.73 0 0 0-.73-.73H4.69c-.25.003-.496.048-.73.135V12.72a8.76 8.76 0 1 1 17.52 0v1.595a2.165 2.165 0 0 0-.73-.135h-2.92a.73.73 0 0 0-.73.73v7.3c0 .403.327.73.73.73h2.92c1.21 0 2.19-.98 2.19-2.19v-8.03C22.934 7.078 18.362 2.506 12.72 2.5z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayHamburgerMenuHeadset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-hamburger-menu-headset.5dd148930cb6d46bf891d6113fcc3314.svg";